"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.PaddingWrap = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var PaddingWrap = _styledComponents["default"].span.withConfig({
  displayName: "styled__PaddingWrap",
  componentId: "x9obj9-0"
})(["display:inline-flex;align-self:center;justify-content:center;align-items:center;padding-top:.1em;", ""], function (_ref) {
  var isLeft = _ref.isLeft;
  return isLeft ? 'padding-right: 3px;' : 'padding-left: 3px;';
});

exports.PaddingWrap = PaddingWrap;